export default "/images/5c2f4cd300377a13193fe55de41161d0.avif";